import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import styles from "../Styles/tables.module.css";
import stylesModal from "../../Components/DeleteModal/deletemodal.module.css";
import axios from "axios";
import { Url, getUser } from "../../Constants/globals";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiSearch, HiX, HiDownload, HiKey, HiCog, HiCreditCard } from "react-icons/hi";
import { TbActivity, TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled, TbMinus } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";
import Loading from "../../Components/Loading/loading";
import MultiSelect from "../../Components/MultiSelect/multiselect";

function ModalPassword({ name, nif, closeModal, setAlert, setLoading }) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);

  async function changePassword() {
    await setAlert("");
    await setLoading(<Loading />);
    try {
      await axios.post(`${Url}/reset-user-password`, {
        nif: nif
      }, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
      await setLoading("");
      await handleClose();
      return setAlert(<Alert type={"success"}>Palavra-passe redefinida com sucesso</Alert>)
    }
    catch (err) {
      if (err.request && err.request.status === 401) {
        var newToken = await RefreshToken(err);
        if (newToken) return await changePassword();
        else window.location.reload();
      }
      else {
        console.error(err);
        setLoading("");
        return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao redefinir a palavra-passe"}</Alert>);
      }
    };
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      <div className={stylesModal.center}>
        <div className={stylesModal.column}>
          <h4 style={{ margin: 0 }}>Ao redefinir a palavra-passe, esta tomará o valor do NIF do utilizador.</h4>
          <h4 style={{ margin: 0 }}>Deseja redefinir a palavra-passe de {name} para {nif}?</h4>
          <div className={stylesModal.buttons}>
            <button className={stylesModal.actionButton} onClick={() => changePassword()}>Redefinir palavra-passe</button>
            <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

async function deleteEmployeeFunction(id, reason) {
  if (!reason) {
    return [0, <Alert type={"error"}>Apresente um motivo</Alert>];
  }
  try {
    await axios.delete(`${Url}/users/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
      data: {
        reason: reason,
      },
    });
    return [200, <Alert type={"success"}>Funcionário eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await deleteEmployeeFunction(id, reason);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o funcionário"}</Alert>];
    }
  };
}

async function changeActivityEmployeeFunction(id, reason) {
  if (!reason) {
    return [0, <Alert type={"error"}>Apresente um motivo</Alert>];
  }
  try {
    await axios
      .post(`${Url}/users/${id}/activity`,
        {
          reason: reason
        },
        {
          headers: {
            Authorization: "Bearer " + getUser().token,
          },
        });
    return [200, <Alert type={"success"}>Funcionário desativado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await changeActivityEmployeeFunction(id, reason);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao desativar o funcionário"}</Alert>];
    }
  };
}

async function exportThisEmployees(page, nome, num, email, empresas, excel, totalUsers, orderBy, setOrderBy) {
  let empresasIds = ``;
  if (empresas?.length > 0) {
    for (const emp of empresas) {
      if (empresasIds) {
        empresasIds += `,${emp.id}`;
      }
      else {
        empresasIds += `${emp.id}`
      }
    }
  }
  if (orderBy && setOrderBy) {
    if (orderBy[0]) setOrderBy(orderBy);
    else setOrderBy(["", ""])
  }

  try {
    const res = await axios.get(`${Url}/export-users?page=${page ? page : 1}${nome ? `&nome=${nome}` : ""}${num ? `&num=${num}` : ""}${email ? `&email=${email}` : ""}${empresasIds ? `&empresa=${empresasIds}` : ""}${excel ? `&excel=1&per_page=${totalUsers}` : ""}${orderBy && orderBy[0] ? `&order_by=${orderBy[0]},${orderBy[1]}` : `&order_by=id,desc`}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
      responseType: "blob"
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await exportThisEmployees(page, nome, num, email, empresas, excel, totalUsers, orderBy, setOrderBy);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getEmployees(page, nome, num, email, empresas, orderby, setorderby) {
  let empresasIds = ``;
  if (empresas?.length > 0) {
    for (const emp of empresas) {
      if (empresasIds) {
        empresasIds += `,${emp.id}`;
      }
      else {
        empresasIds += `${emp.id}`
      }
    }
  }
  if (orderby && setorderby) {
    if (orderby[0]) setorderby(orderby);
    else setorderby(["", ""])
  }

  try {
    const res = await axios.get(`${Url}/employees?page=${page ? page : 1}${nome ? `&nome=${nome}` : ""}${num ? `&num=${num}` : ""}${email ? `&email=${email}` : ""}${empresasIds ? `&empresa=${empresasIds}` : ""}${orderby && orderby[0] ? `&order_by=${orderby[0]},${orderby[1]}` : ""}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      }
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getEmployees(page, nome, num, email, empresas, orderby, setorderby);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getCompanies() {
  try {
    const res = await axios
      .get(`${Url}/companies?per_page=300`, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getCompanies();
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Funcionarios({ userPermissions }) {

  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const searchRef = useRef(null);

  const [loading, setLoading] = useState("");
  const [modalPassword, setModalPassword] = useState("");
  const [loadingData, setLoadingData] = useState(true);
  const [employeesData, setEmployeesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [nextPage, setNextPage] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [previousPage, setPreviousPage] = useState("");
  const [deleteEmployee, setDeleteEmployee] = useState("");
  const [alert, setAlert] = useState("");
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState(state?.nomeSearch ? state.nomeSearch : "");
  const [numSearch, setNumSearch] = useState(state?.numSearch ? state.numSearch : "");
  const [emailSearch, setEmailSearch] = useState(state?.emailSearch ? state.emailSearch : "");
  const [empresasSearch, setEmpresasSearch] = useState(state?.empresasSearch ? state.empresasSearch : []);
  const [showSearch, setShowSearch] = useState(nomeSearch || numSearch || emailSearch || empresasSearch?.length > 0 ? true : false);
  const [companies, setCompanies] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [orderBy, setOrderBy] = useState(state?.order ? state.order : ["", ""]);

  async function assignData() {
    const thisCompaniesData = await getCompanies();
    setCompanies(thisCompaniesData.companies);
    const thisEmployeesData = await getEmployees(currentPage, nomeSearch, numSearch, emailSearch, empresasSearch, orderBy, setOrderBy);
    setCurrentPage(thisEmployeesData.current_page);
    setNextPage(thisEmployeesData.next_page);
    setPreviousPage(thisEmployeesData.prev_page);
    setPerPage(thisEmployeesData.per_page);
    setEmployeesData(thisEmployeesData);
    setTotalUsers(thisEmployeesData.total_users);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newEmployeesData = await getEmployees(start ? start : nextPage, nomeSearch, numSearch, emailSearch, empresasSearch, orderBy, setOrderBy);
      setEmployeesData(newEmployeesData);
      setCurrentPage(newEmployeesData.current_page);
      setNextPage(newEmployeesData.next_page);
      setPreviousPage(newEmployeesData.prev_page);
      setPerPage(newEmployeesData.per_page);
      setTotalUsers(newEmployeesData.total_users);
      navigate(location.pathname, { replace: true, state: { page: start ? start : nextPage, nomeSearch: nomeSearch, numSearch: numSearch, emailSearch: emailSearch, empresasSearch: empresasSearch, order: orderBy } });
    }
    else if (!next && previousPage) {
      const newEmployeesData = await getEmployees(previousPage, nomeSearch, numSearch, emailSearch, empresasSearch, orderBy, setOrderBy);
      setEmployeesData(newEmployeesData);
      setCurrentPage(newEmployeesData.current_page);
      setNextPage(newEmployeesData.next_page);
      setPreviousPage(newEmployeesData.prev_page);
      setPerPage(newEmployeesData.per_page);
      setTotalUsers(newEmployeesData.total_users);
      navigate(location.pathname, { replace: true, state: { page: previousPage, nomeSearch: nomeSearch, numSearch: numSearch, emailSearch: emailSearch, empresasSearch: empresasSearch, order: orderBy } });
    }
    else {
      return;
    }
  }

  const handleSearchContainer = () => {
    if (showSearch) {
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      }, 280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false) {
      setNomeSearch("");
      setNumSearch("");
      setEmailSearch("");
      setEmpresasSearch([]);
    }
    const searchEmployeesData = await getEmployees(1, input === false ? "" : nomeSearch, input === false ? "" : numSearch, input === false ? "" : emailSearch, input === false ? [] : empresasSearch, orderBy, setOrderBy);
    setCurrentPage(searchEmployeesData.current_page);
    setNextPage(searchEmployeesData.next_page);
    setPreviousPage(searchEmployeesData.prev_page);
    setPerPage(searchEmployeesData.per_page);
    setEmployeesData(searchEmployeesData);
    setTotalUsers(searchEmployeesData.total_users);
    navigate(location.pathname, { replace: true, state: { page: 1, nomeSearch: input === false ? "" : nomeSearch, numSearch: input === false ? "" : numSearch, emailSearch: input === false ? "" : emailSearch, empresasSearch: input === false ? [] : empresasSearch, order: orderBy } });
  }

  function getLastPage() {
    const calc = totalUsers / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  async function getAlertDelete(id, reason) {
    if (id) {
      await setAlert("");
      const res = await deleteEmployeeFunction(id, reason);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  async function getAlertActivity(id, reason) {
    if (id) {
      await setAlert("");
      const res = await changeActivityEmployeeFunction(id, reason);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  async function exportEmployees() {
    await setAlert("");
    await setLoading(<Loading />);
    const newEmployeesData = await exportThisEmployees(1, nomeSearch, numSearch, emailSearch, empresasSearch, true, 1000000, orderBy);
    if (!newEmployeesData || newEmployeesData.length === 0) {
      setLoading("");
      return setAlert(<Alert type="error">Ocorreu um erro ao exportar o ficheiro</Alert>);
    }
    else {
      const fileURL = URL.createObjectURL(newEmployeesData);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', "Colaboradores_AFA_ONE");
      document.body.appendChild(link);
      link.click();
      return setLoading("");
    }
  }

  async function handleOrderBy(field) {
    let finalAnswer = ["", ""];
    if (orderBy[0] && orderBy[0] !== field) {
      finalAnswer = [field, "asc"];
    }
    else {
      if (orderBy[1] === "asc") {
        finalAnswer = [field, "desc"];
      }
      else if (orderBy[1] === "desc") {
        finalAnswer = ["", ""];
      }
      else {
        finalAnswer = [field, "asc"];
      }
    }
    const searchEmployeesData = await getEmployees(1, nomeSearch, numSearch, emailSearch, empresasSearch, finalAnswer, setOrderBy);
    setCurrentPage(searchEmployeesData.current_page);
    setNextPage(searchEmployeesData.next_page);
    setPreviousPage(searchEmployeesData.prev_page);
    setPerPage(searchEmployeesData.per_page);
    setEmployeesData(searchEmployeesData);
    setTotalUsers(searchEmployeesData.total_users);
    navigate(location.pathname, { replace: true, state: { page: 1, nomeSearch: nomeSearch, numSearch: numSearch, emailSearch: emailSearch, empresasSearch: empresasSearch, order: finalAnswer } });
  }

  function checkOrder(field) {
    if (orderBy[0] && orderBy[0] === field) {
      if (orderBy[1] === "asc") return "▼";
      else if (orderBy[1] === "desc") return "▲";
      else return "";
    }
    else return "";
  }

  return (
    <div className="body">
      {modalPassword}
      {alert}
      {loading}
      {deleteEmployee}
      <NavBar current={"colaboradores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
          :
          <div style={{ position: "relative" }}>
            <div className={styles.tableButtons}>
              <button className={styles.btnAdd} onClick={() => navigate("/colaboradores/adicionar")}>
                <HiPlus size={20} />
                <p className={styles.textAdd}>Adicionar</p>
              </button>
              <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
                <HiSearch size={20} />
                <p className={styles.textAdd}>Procurar</p>
              </button>
              <button className={styles.btnAprove} onClick={() => exportEmployees()}>
                <HiDownload size={20} />
                <p className={styles.textAdd}>Exportar</p>
              </button>
              {
                userPermissions?.cartoes ?
                  <button className={styles.btnExport} onClick={() => navigate("/cartoes")}>
                    <HiCreditCard size={20} />
                    <p className={styles.textAdd}>Cartões</p>
                  </button>
                  : ""
              }
            </div>
            {/* <button className={styles.btnImport} title="Importar excel" onClick={() => handleFileUpload()}>
            <HiUpload size={20}/>
            <p className={styles.textAdd}>Importar</p>
            <input type="file" ref={fileInputRef} onChange={(e) => handleUploadExcel(e)} style={{display: "none"}} />
          </button> */}
            <div className={styles.content}>
              {
                showSearch ?
                  <div style={{ padding: "1rem 0", gap: "5px" }} className={`${styles.employeesColumnSearch} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}>
                    <p></p>
                    <input
                      className={`${styles.searchInput}`}
                      style={{ minWidth: "auto" }}
                      placeholder="Nº"
                      value={numSearch}
                      onChange={(e) => setNumSearch(e.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                    <input
                      style={{ minWidth: "auto" }}
                      ref={searchRef}
                      value={nomeSearch}
                      className={`${styles.searchInput}`}
                      onChange={(e) => setNomeSearch(e.target.value)}
                      placeholder="Nome"
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                    <input
                      style={{ minWidth: "auto" }}
                      className={`${styles.searchInput}`}
                      placeholder="Email"
                      value={emailSearch}
                      onChange={(e) => setEmailSearch(e.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                    <MultiSelect
                      removeBottomSelectedItems
                      style={{ minWidth: "auto" }}
                      className={`${styles.searchInput}`}
                      items={companies}
                      value={empresasSearch}
                      onValueChange={setEmpresasSearch}
                      placeholder={`Empresas (${empresasSearch.length})`}
                    />
                    <div className={styles.searchButtons}>
                      <button className={styles.btn} style={{ cursor: "default", marginRight: "0" }} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c" /></button>
                      <button className={styles.btn} style={{ marginLeft: "0" }} onClick={() => handleSearch()}><HiSearch size={18} /></button>
                    </div>
                  </div>
                  : ""
              }
              <div className={styles.table3buttons}>
                <div className={styles.employeesColumn}>
                  <p></p>
                  <p style={{ cursor: "pointer" }} onClick={() => handleOrderBy("num")}>Nº{checkOrder("num")}</p>
                  <p style={{ cursor: "pointer" }} onClick={() => handleOrderBy("full_name")}>Nome{checkOrder("full_name")}</p>
                  <p>Email</p>
                  <p>Empresa</p>
                  <p>Ações</p>
                </div>
                <div className={styles.scrollContent}>
                  {
                    employeesData?.users?.length > 0 ?
                      employeesData?.users?.map((user, index) =>
                        <div key={user.id} className={styles.employeesInfo} style={index % 2 !== 0 ? { backgroundColor: "var(--inputBackground)" } : {}}>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            {
                              user.photo_uri && user.approved ?
                                <img className={styles.foto} alt="img" src={`${Url}/image/${user.photo_uri}`} />
                                :
                                <img className={styles.noFoto} alt="img" />
                            }
                          </div>
                          <p title={user.num ? user.num : ""}>{user.num ? user.num : "-"}</p>
                          <p title={user.full_name ? user.full_name : ""}>{user.full_name ? user.full_name : "-"}</p>
                          <p title={user.email ? user.email : ""}>{user.email ? user.email : "-"}</p>
                          <p title={user.company ? user.company?.name : ""}>{user.company ? user.company?.name : "-"}</p>
                          <div className={styles.actions}>
                            {
                              user.is_active ?
                                <HiKey title="Redefinir palavra-passe" className={styles.icon} onClick={() => setModalPassword(<ModalPassword name={user.full_name} nif={user.nif} closeModal={setModalPassword} setAlert={setAlert} setLoading={setLoading} />)} size={22} />
                                : ""
                            }
                            <HiPencil onClick={() => navigate("/colaboradores/" + user.id, { state: { page: currentPage, nomeSearch: nomeSearch, numSearch: numSearch, emailSearch: emailSearch, empresasSearch: empresasSearch, order: orderBy } })} className={styles.icon} size={22} />
                            <HiCog className={styles.icon} onClick={() => setDeleteEmployee(<DeleteModal close={setDeleteEmployee} user={true} objectId={user.id} objectName={user.full_name} deleteFunction={getAlertDelete} reason={true} userActivity={user.is_active} changeActivity={getAlertActivity} />)} size={22} />
                          </div>
                          <div className={styles.actions}>
                            {
                              user.is_active ?
                                <TbActivity size={22} color={"var(--successBackground)"} title={"Ativo"} />
                                :
                                <TbMinus size={22} color={"var(--errorBackground)"} title={"Inativo"} />
                            }
                          </div>
                        </div>
                      )
                      :
                      <div className={styles.noData}>
                        <p>Não existem dados</p>
                      </div>
                  }
                </div>
                {
                  previousPage || nextPage ?
                    <div className={styles.arrows}>
                      <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => previousPage && handlePageChange(true, 1)} />
                      <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => previousPage && handlePageChange(false)} />
                      {currentPage ? currentPage : ""}
                      <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => nextPage && handlePageChange(true)} />
                      <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => nextPage && handlePageChange(true, getLastPage())} />
                    </div>
                    : ""
                }
              </div>
            </div>
          </div>
      }
    </div>
  );
}

export default Funcionarios;